import React from 'react'
import IMGUploadComponent from '../../../../../components/IMGUploadComponent'
import { useForm } from 'react-hook-form'

function Identity() {
    const {
        handleSubmit,
      } = useForm({
        
      });

      const onSubmit = (data: any) => {
      };
      
  return (
    <div>
       <form className="auth-login-form mt-3" onSubmit={handleSubmit(onSubmit)}>
            <IMGUploadComponent
              imageUrl=""
              onUpload={(e: any) => {}}
            />
            
          </form>
    </div>
  )
}

export default Identity;